/* Energy / Sleep toggle shared by the hero and the homepage sticky bar. */
(function () {
  function apply(ritual) {
    document.querySelectorAll('[data-vf-ritual-tab]').forEach(function (t) { var on = t.dataset.vfRitualTab === ritual; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    document.querySelectorAll('[data-vf-ritual-panel],[data-vf-ritual-tube]').forEach(function (p) { p.classList.toggle('is-active', (p.dataset.vfRitualPanel || p.dataset.vfRitualTube) === ritual); });
    document.querySelectorAll('[data-vf-ritual-root]').forEach(function (r) { r.setAttribute('data-ritual', ritual); });
  }
  document.addEventListener('click', function (e) { var t = e.target.closest('[data-vf-ritual-tab]'); if (t) apply(t.dataset.vfRitualTab); });
  var first = document.querySelector('[data-vf-hero]'); if (first && first.dataset.default) apply(first.dataset.default);
})();
